const CAD_DISPLAY_PATTERN = /\bCAD\b/g;

const cadCurrencyFormatter = new Intl.NumberFormat("fr-CA", {
  style: "currency",
  currency: "CAD",
  currencyDisplay: "narrowSymbol",
  maximumFractionDigits: 2,
});

export function normalizeCurrencyDisplay(value) {
  if (typeof value !== "string") {
    return value;
  }

  return value.replace(CAD_DISPLAY_PATTERN, "$");
}

export function formatCurrencyDisplay(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  return normalizeCurrencyDisplay(cadCurrencyFormatter.format(numericValue));
}